var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#4BD391",
    fillOpacity: 0.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.665 38.434h69.13v63.555h-69.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4BD391",
    d: "M122.231 66a56.232 56.232 0 0 1-95.992 39.761A56.23 56.23 0 1 1 122.231 66ZM94.326 44.703a5.271 5.271 0 0 0-7.59.154L62.323 75.96l-14.71-14.718a5.272 5.272 0 0 0-7.45 7.45L58.76 87.297a5.271 5.271 0 0 0 7.584-.14l28.06-35.074a5.272 5.272 0 0 0-.07-7.38h-.008Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h112.461v112.461H0z",
    transform: "translate(9.77 9.77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredCheck);
export default __webpack_public_path__ + "static/media/coloredCheck.a37c5fc99d8d5a53be80f807ab31ebc8.svg";
export { ForwardRef as ReactComponent };